<template>
  <PageWrapper :isLoading="isLoading" v-if="defaultLessonDetails">
    <template #title> ویرایش درس {{ defaultLessonDetails.title }} </template>
    <BRow>
      <BCol cols="12" md="6">
        <TextInput
          inputId="title"
          inputLabel="عنوان جلسه"
          inputPlaceholder="ویدیو درس آیلتس مقدماتی"
          v-model="lessonDetails.title"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <CustomAppendText
          :isText="true"
          type="text"
          inputmode="numeric"
          customRules="required|min:1"
          inputId="price"
          inputLabel="قیمت جلسه"
          inputPlaceholder="60000"
          v-model="lessonDetails.price"
        >
          <template #append> تومان </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12">
        <CustomTextarea
          rows="3"
          inputId="desc"
          inputLabel="توضیحات جلسه"
          inputPlaceholder="توضیحات..."
          :maxChars="3000"
          customRules="max:3000"
          :charsCount="
            lessonDetails.description ? lessonDetails.description.length : 0
          "
          v-model="lessonDetails.description"
        ></CustomTextarea>
      </BCol>
      <BCol cols="12">
        <BFormCheckbox
          v-model="lessonDetails.isRequired"
          name="isRequiredSwitch"
          switch
        >
          <small style="margin-left: 3px"> آیا این جلسه اجباری است؟ </small>
          <b>({{ lessonDetails.isRequired ? "بله" : "خیر" }})</b>
        </BFormCheckbox>
      </BCol>
      <BCol cols="12">
        <BFormGroup label="عکس کاور کلاس" label-for="imageFile">
          <BFormFile
            ref="imageFile"
            id="imageFile"
            accept=".jpg,.jpeg,.png"
            @input="convertImageFileToBase64"
          ></BFormFile>
        </BFormGroup>
      </BCol>
      <BCol v-if="imagePreview" cols="12">
        <BRow>
          <BCol class="mx-auto position-relative" cols="10" md="6">
            <BImg fluid-grow :src="imagePreview" height="300"></BImg>
            <BButton
              @click="removeImagePreview"
              class="delete-icon"
              variant="transparent"
              size="sm"
            >
              <FeatherIcon icon="Trash2Icon" size="23" class="text-danger" />
            </BButton>
          </BCol>
        </BRow>
      </BCol>
      <BCol cols="12">
        <CustomSelect
          class="w-100"
          inputId="objectSkillType"
          inputLabel="مشخص کردن نوع محتوا درس"
          :customOptions="objectSkillTypesOptions"
          v-model="skillType"
        ></CustomSelect>
      </BCol>
      <BCol cols="12">
        <div class="w-100 d-flex align-items-center justify-content-end">
          <BButton
            :disabled="!skillType"
            variant="update"
            @click="createObjectSkillType"
          >
            افزودن نوع محتوا به درس
          </BButton>
        </div>
      </BCol>
      <BCol cols="12" class="mt-2">
        <template v-if="skillTypesList && skillTypesList.length > 0">
          <p>نوع محتوا های فعلی درس:</p>
          <div class="w-100 d-flex align-items-center" style="gap: 0.5rem">
            <BBadge
              style="font-weight: normal; vertical-align: middle"
              class="p-1 d-flex align-items-center justify-content-between"
              variant="info"
              v-for="item in skillTypesList"
              :key="item.objectSkillTypeId"
            >
              <span style="padding-top: 3px">
                {{ objectSkillTypesEnum[item.skillType] }}
              </span>
              <BButton
                size="sm"
                variant="transparent"
                type="button"
                class="p-0 ml-1"
                @click="renderObjectSkillTypeDeleteConfirmation(item)"
              >
                <FeatherIcon size="35" icon="XIcon" class="text-white" />
              </BButton>
            </BBadge>
          </div>
        </template>
      </BCol>
      <BCol cols="12">
        <div class="my-2">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center justify-start">
              <p class="mb-0 mr-1">رسانه های کلاس</p>
              <BButton @click="fetchArvanStatus" variant="primary" size="sm">
                بروزرسانی ویدیو ها
              </BButton>
            </div>
            <div class="d-flex align-items-center">
              <p class="mb-0 mr-1">نحوه نمایش:</p>
              <div
                @click="isGallery = true"
                style="cursor: pointer"
                class="d-flex align-items-center"
              >
                <p class="mb-0" :class="isGallery ? 'text-primary' : ''">
                  گالری
                </p>
                <FeatherIcon
                  icon="GridIcon"
                  size="15"
                  class="ml-1"
                  :class="isGallery ? 'text-primary' : ''"
                />
              </div>
              <span class="mx-1">|</span>
              <div
                @click="isGallery = false"
                :class="isGallery ? '' : 'text-primary'"
                style="cursor: pointer"
                class="d-flex align-items-center"
              >
                <p class="mb-0" :class="isGallery ? '' : 'text-primary'">
                  مجزا
                </p>
                <FeatherIcon
                  icon="ListIcon"
                  size="15"
                  class="ml-1"
                  :class="isGallery ? '' : 'text-primary'"
                />
              </div>
            </div>
          </div>
          <hr />
        </div>
      </BCol>
      <BCol cols="12">
        <LessonMediaList
          v-if="!isGallery"
          :videoFilesConcated="videoFilesConcated"
          :imageFilesConcated="imageFilesConcated"
          :audioFilesConcated="audioFilesConcated"
          :textFilesConcated="textFilesConcated"
          @deleteVideo="deleteVideo"
          @getVideoArray="setVideoArray"
          @deletePicture="deletePicture"
          @getImageArray="setImageArray"
          @getAudioArray="setAudioArray"
          @deleteAudio="deleteAudio"
          @getTextArray="setTextArray"
          @deleteText="deleteText"
          @refetch="getLessonMedias"
        ></LessonMediaList>
        <LessonMediaGrid
          v-if="isGallery"
          :videoFilesConcated="videoFilesConcated"
          :imageFilesConcated="imageFilesConcated"
          :audioFilesConcated="audioFilesConcated"
          :textFilesConcated="textFilesConcated"
          @deleteVideo="deleteVideo"
          @getVideoArray="setVideoArray"
          @deletePicture="deletePicture"
          @getImageArray="setImageArray"
          @getAudioArray="setAudioArray"
          @deleteAudio="deleteAudio"
          @getTextArray="setTextArray"
          @deleteText="deleteText"
          @refetch="getLessonMedias"
        ></LessonMediaGrid>
      </BCol>
      <BCol cols="12" v-if="uploaded" class="mt-1 mb-2">
        <div class="progress-wrapper">
          <p class="mb-0">در حال آپلود {{ uploaded + "%" }}</p>
          <b-progress animated v-model="uploaded" max="100" />
        </div>
      </BCol>
      <BCol cols="12">
        <div class="d-flex align-items-center justify-content-end">
          <BButton
            :disabled="isLoading || uploaded"
            variant="primary"
            @click="sendUpdateRequest"
          >
            بروزرسانی
          </BButton>
        </div>
      </BCol>
    </BRow>
    <ObjectSkillTypeDeleteConfirmationDialog
      :defaultObjectType="tempObjectSkillType"
      @refetch="getAllObjectSkillTypes"
    >
    </ObjectSkillTypeDeleteConfirmationDialog>
    <LessonMediaDeleteConfirmationDialog
      @refetch="getLessonMedias"
      :tempDeleteArray="tempDeleteArray"
      :tempVideoObject="tempVideoObject"
    >
    </LessonMediaDeleteConfirmationDialog>
  </PageWrapper>
</template>
<script>
export default {
  async mounted() {
    await this.getALesson();
    this.getLessonMedias();
    this.getQuestionsCountForLesson();
    this.getAllObjectSkillTypes();
  },
  data() {
    return {
      // This value decide which component to load
      isGallery: false,
      lessonDetails: null,
      // the variable blow is needed to keep
      // previous data of lesson
      defaultLessonDetails: null,
      lessonMedias: null,
      isLoading: false,
      tempBase64: null,
      lessonImage: null,
      mediaFiles: [],
      // This Value (uploaded) is updated from WebServiceRequest class automatically
      uploaded: null,
      videoFiles: [],
      imageFiles: [],
      audioFiles: [],
      textFiles: [],
      // This variable must hold
      // String array during rendering
      // Of delete confirmation modal
      tempDeleteArray: null,
      isUpdatingLessonQuestionsCount: false,
      lessonQuestionsCount: {
        isDeleted: false,
        lessenQuestionsCountId: 0,
        lessonId: this.$route.params.id,
        easy: null,
        medium: null,
        hard: null,
        veryHard: null,
        createDate: new Date(Date.now()),
      },
      skillTypesList: null,
      // SkillType is the new value
      // That will be added
      skillType: null,
      objectSkillTypesEnum: {
        1: "شنیداری (Listening)",
        2: "گفتاری (Speaking)",
        3: "خواندن (Reading)",
        4: "نوشتاری (Writing)",
      },
      objectSkillTypesOptions: [
        // Listening = 1,
        // Speaking = 2,
        // Reading = 3,
        // Writing = 4,
        // All = 5
        {
          value: null,
          text: "در صورت تمایل یک گزینه را انتخاب کنید",
        },
        {
          value: 1,
          text: "شنیداری (Listening)",
        },
        {
          value: 2,
          text: "گفتاری (Speaking)",
        },
        {
          value: 3,
          text: "خواندن (Reading)",
        },
        {
          value: 4,
          text: "نوشتاری (Writing)",
        },
      ],
      // This variable is here to get
      // Removing item details
      tempObjectSkillType: null,
      tempVideoObject: null,
    };
  },
  methods: {
    removeImagePreview() {
      this.lessonImage = null;
    },
    renderObjectSkillTypeDeleteConfirmation(item) {
      this.tempObjectSkillType = JSON.parse(JSON.stringify(item));
      this.$bvModal.show("object-skill-type-delete-confirmation-dialog");
    },
    async fetchArvanStatus() {
      try {
        this.isLoading = true;
        let _this = this;
        let updateArvanVideoStatus = new UpdateArvanVideoStatus(_this);
        await updateArvanVideoStatus.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "بروز شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "وضعیت ویدیو ها با موفقیت بروز شد.",
              },
            });
            _this.getLessonMedias();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async createObjectSkillType() {
      try {
        this.isLoading = true;
        let _this = this;
        let createAnObjectSkillType = new CreateAnObjectSkillType(_this);
        createAnObjectSkillType.setRequestParamDataObj({
          isDeleted: false,
          objectSkillTypeId: 0,
          objectId: _this.$route.params.id,
          objectType: 1,
          skillType: _this.skillType,
          createDate: new Date(Date.now()),
        });
        await createAnObjectSkillType.fetch(function (response) {
          if (response.isSuccess) {
            _this.getAllObjectSkillTypes();
          }
        });
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "نوع محتوای درس تکراری است",
            icon: "EditIcon",
            variant: "danger",
          },
        });
        console.error(error);
      } finally {
        this.skillType = null;
        this.isLoading = false;
      }
    },
    async getAllObjectSkillTypes() {
      try {
        this.isLoading = true;
        let _this = this;
        let getObjectSkillTypesOfProduct = new GetObjectSkillTypesOfProduct(
          _this
        );
        // SklillObjectType for lesson is 1, 2 is for course
        getObjectSkillTypesOfProduct.setRequestParam({
          count: 0,
          pageNumber: 0,
          skillObjectType: 1,
          objectId: _this.$route.params.id,
        });
        await getObjectSkillTypesOfProduct.fetch(function (response) {
          if (response.isSuccess) {
            _this.skillTypesList = response.data.objectSkillTypes;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getQuestionsCountForLesson() {
      try {
        let _this = this;
        let getAllLessonQuestionsCount = new GetAllLessonQuestionsCount(_this);
        getAllLessonQuestionsCount.setRequestParam({
          count: 0,
          pageNumber: 0,
          lessonId: _this.$route.params.id,
        });
        await getAllLessonQuestionsCount.fetch(
          function (response) {
            if (
              response.lessenQuestionsCounts &&
              response.lessenQuestionsCounts.length > 0
            ) {
              _this.isUpdatingLessonQuestionsCount = true;
              _this.lessonQuestionsCount = response.lessenQuestionsCounts[0];
            }
          },
          function (error) {
            console.log(error);
          }
        );
      } catch (error) {
        console.error(error);
      }
    },
    async createQuestionsCountForLesson() {
      try {
        let _this = this;
        let createLessonQuestionsCount = new CreateLessonQuestionsCount(_this);
        createLessonQuestionsCount.setRequestParamDataObj([
          _this.lessonQuestionsCount,
        ]);
        await createLessonQuestionsCount.fetch(
          function (response) {
            _this.getQuestionsCountForLesson();
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      }
    },

    deleteText(textFile) {
      if (typeof textFile === "object") {
        this.textFiles = this.textFiles.filter((item) => item != textFile);
      } else {
        this.tempDeleteArray = [textFile];
        this.$bvModal.show("lesson-media-delete-confirmation-dialog");
      }
    },
    deleteAudio(audioFile) {
      if (typeof audioFile === "object") {
        this.audioFiles = this.audioFiles.filter((item) => item != audioFile);
      } else {
        this.tempDeleteArray = [audioFile];
        this.$bvModal.show("lesson-media-delete-confirmation-dialog");
      }
    },
    deletePicture(pictureFile) {
      if (typeof pictureFile === "object") {
        this.imageFiles = this.imageFiles.filter((item) => item != pictureFile);
      } else {
        this.tempDeleteArray = [pictureFile];
        this.$bvModal.show("lesson-media-delete-confirmation-dialog");
      }
    },
    deleteVideo(videoFile) {
      if (videoFile && !videoFile.mediaId) {
        this.videoFiles = this.videoFiles.filter((item) => item != videoFile);
      } else {
        this.tempVideoObject = videoFile;
        this.tempDeleteArray = [videoFile.pictureUrl];
        this.$bvModal.show("lesson-media-delete-confirmation-dialog");
      }
    },
    setTextArray(textArray) {
      textArray.forEach((item) =>
        this.textFiles.push({
          File: item,
          Title: "",
          Description: "",
        })
      );
    },
    setAudioArray(audioArray) {
      audioArray.forEach((item) =>
        this.audioFiles.push({
          File: item,
          Title: "",
          Description: "",
        })
      );
    },
    setImageArray(imageArray) {
      imageArray.forEach((item) =>
        this.imageFiles.push({
          File: item,
          Title: "",
          Description: "",
        })
      );
    },
    setVideoArray(videoArray) {
      videoArray.forEach((item) =>
        this.videoFiles.push({
          File: item,
          Title: "",
          Description: "",
        })
      );
    },
    async getLessonMedias() {
      this.tempVideoObject = null;
      let _this = this;
      let getLessonMedias = new GetLessonMedias(_this);
      getLessonMedias.setRequestParam({
        lessonId: _this.$route.params.id,
      });
      await getLessonMedias.fetch(
        function (response) {
          _this.lessonMedias = response.data;
        },
        function (error) {
          console.error(error);
        }
      );
    },
    handleMediaView(file) {
      // Deciding whether file is blob or url
      if (typeof file === "object") {
        return URL.createObjectURL(file);
      } else if (typeof file === "string") {
        return `${this.baseUrl}/${file}`;
      }
    },
    async uploadLessonMedias() {
      try {
        // let formData = new FormData();
        // for (let i = 0; i < this.mediaFiles.length; i++) {
        //   // HERE
        //   Object.keys(this.mediaFiles[i]).forEach((key)=>{

        //     formData.append(`files`, this.mediaFiles[i]);
        //   })
        // }
        let _this = this;
        let uploadLessonFiles = new UploadLessonFiles(_this);
        uploadLessonFiles.setRequestParam({
          lessonId: _this.$route.params.id,
        });
        uploadLessonFiles.setFormData(
          helper.generateFormData({ files: _this.mediaFiles })
        );
        await uploadLessonFiles.sendFormData(
          function (response) {
            _this.uploaded = null;
            _this.videoFiles = [];
            _this.imageFiles = [];
            _this.audioFiles = [];
            _this.textFiles = [];
            _this.getLessonMedias();
            _this.getALesson();
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      }
    },
    async sendUpdateRequest() {
      // Push all media files together
      this.mediaFiles = [
        ...this.videoFiles,
        ...this.audioFiles,
        ...this.imageFiles,
        ...this.textFiles,
      ];
      try {
        this.lessonDetails.mainImage = this.lessonImage;
        let myFormData = new FormData();
        Object.keys(this.lessonDetails).forEach((key) => {
          if (this.lessonDetails[key]) {
            myFormData.append(key, this.lessonDetails[key]);
          }
        });
        this.isLoading = true;
        let _this = this;
        let updateASingleLesson = new UpdateAnIndependentLesson(_this);
        _this.lessonDetails.dependency = null;
        updateASingleLesson.setFormData(myFormData);
        await updateASingleLesson.sendFormData(
          function (response) {
            if (response.data.isSuccess) {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "موفقیت آمیز بود",
                  icon: "EditIcon",
                  variant: "success",
                  text: "کلاس با موفقیت ویرایش شد.",
                },
              });
              _this.getALesson();
            } else {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "مشکلی پیش آمد!",
                  icon: "XIcon",
                  variant: "danger",
                  text: res.errors || "لطفا دوباره تلاش کنید",
                },
              });
            }
            if (_this.mediaFiles && _this.mediaFiles.length > 0) {
              let size = 0;
              _this.mediaFiles.forEach((file) => (size += file.size));
              const sizeInMb = size / 1024 / 1024;
              if (sizeInMb > 500) {
                _this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "مشکل در آپلود",
                    text: "حجم فایل های ارسالی به صورت کلی نباید بیشتر از 500 مگابایت باشد!",
                    icon: "EditIcon",
                    variant: "danger",
                  },
                });
              } else {
                _this.uploadLessonMedias();
              }
            } else {
              _this.uploaded = null;
            }
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    convertImageFileToBase64(file) {
      if (file) {
        this.lessonImage = file;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async () => {
          this.tempBase64 = reader.result.split(",")[1];
        };
      }
    },
    async getALesson() {
      try {
        this.isLoading = true;
        let _this = this;
        let getASingleLesson = new GetAnIndependentLesson(_this);
        getASingleLesson.setRequestParam({
          id: _this.$route.params.id,
        });
        await getASingleLesson.fetch(
          function (response) {
            _this.defaultLessonDetails = response;
            _this.lessonDetails = JSON.parse(
              JSON.stringify(_this.defaultLessonDetails)
            );
            _this.lessonImage = _this.lessonDetails.picUrl;
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    // These computed concated functions return new file blobs
    // And old uploaded files together
    videoFilesConcated() {
      if (
        (this.lessonMedias && this.lessonMedias.videos) ||
        (this.videoFiles && this.videoFiles.length > 0)
      ) {
        return [...this.lessonMedias.videos, ...this.videoFiles];
      }
    },
    imageFilesConcated() {
      if (
        (this.lessonMedias && this.lessonMedias.images) ||
        (this.imageFiles && this.imageFiles.length > 0)
      ) {
        return [...this.lessonMedias.images, ...this.imageFiles];
      }
    },
    audioFilesConcated() {
      if (
        (this.lessonMedias && this.lessonMedias.podcasts) ||
        (this.audioFiles && this.audioFiles.length > 0)
      ) {
        return [...this.lessonMedias.podcasts, ...this.audioFiles];
      }
    },
    textFilesConcated() {
      if (
        (this.lessonMedias && this.lessonMedias.pdFs) ||
        (this.textFiles && this.textFiles.length > 0)
      ) {
        return [...this.lessonMedias.pdFs, ...this.textFiles];
      }
    },
    imagePreview() {
      if (
        this.lessonImage &&
        this.lessonImage.length > 0 &&
        this.lessonImage !== null &&
        typeof this.lessonImage === "string" &&
        this.lessonImage.includes(".")
      ) {
        return `${this.baseUrl}/Media/Gallery/Lesson/${this.lessonImage}`;
      } else if (
        this.lessonImage !== null &&
        this.lessonImage !== null &&
        typeof this.lessonImage === "object"
      ) {
        return URL.createObjectURL(this.lessonImage);
      } else {
        return null;
      }
    },
    baseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
  },
  components: {
    PageWrapper,
    TextInput,
    CustomAppendText,
    CustomTextarea,
    CustomSelect,
    ObjectSkillTypeDeleteConfirmationDialog,
    LessonMediaDeleteConfirmationDialog,
    LessonMediaList,
    LessonMediaGrid,
    BRow,
    BCol,
    BFormGroup,
    BFormFile,
    BProgress,
    BFormCheckbox,
    BButton,
    BBadge,
    BImg,
  },
};
import { UpdateArvanVideoStatus } from "@/libs/Api/ArvanCloud";
import {
  GetAnIndependentLesson,
  UpdateAnIndependentLesson,
} from "@/libs/Api/IndependentLesson";
import { GetLessonMedias, UploadLessonFiles } from "@/libs/Api/Lesson";
import {
  CreateAnObjectSkillType,
  GetObjectSkillTypesOfProduct,
} from "@/libs/Api/ObjectSkillType";
import {
  CreateLessonQuestionsCount,
  GetAllLessonQuestionsCount,
} from "@/libs/Api/LessonQuestionsCount";
import LessonMediaList from "@/views/components/Lessons/LessonMediaList.vue";
import LessonMediaGrid from "@/views/components/Lessons/LessonMediaGrid.vue";
import PropertySection from "@/views/components/Properties/PropertySection.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";
import CustomTextarea from "@/views/components/Utils/CustomTextarea.vue";
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
import ObjectSkillTypeDeleteConfirmationDialog from "@/views/apps/lessons/ObjectSkillTypeDeleteConfirmationDialog.vue";
import LessonMediaDeleteConfirmationDialog from "@/views/apps/lessons/LessonMediaDeleteConfirmationDialog.vue";
import helper from "@/libs/Helper";

import {
  BRow,
  BCol,
  BFormGroup,
  BFormFile,
  BProgress,
  BFormCheckbox,
  BButton,
  BBadge,
  BImg,
} from "bootstrap-vue";
</script>
<style scoped>
.delete-icon {
  position: absolute;
  top: 0;
  right: -30px;
}
</style>
